// extracted by mini-css-extract-plugin
export default {"iconExternalLink":"IconExternalLink_iconExternalLink__FRZrb","fadeIn":"IconExternalLink_fadeIn__JOepl","hoverLineLink":"IconExternalLink_hoverLineLink__7wN0s"};